const DownloadBudgetEnum = Object.freeze({
  DEFAULT: 0,
  FROM_CERTIFICATION: 1,
  FROM_HISTORY_CERTIFICATION: 2,
  FROM_EXTRAS_AND_CONTRADICTIONS: 3,
})

export default DownloadBudgetEnum
